import { env } from '@/config/env'
import ky from 'ky'

export const tannlegeforeningenApi = ky.create({
  prefixUrl: env.VITE_API_URL,
  credentials: 'include',
  timeout: 1000 * 120,
})
